'use es6';

import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
import EmailTemplateModeSelectModalBody from 'EmailComponents/emailCreation/EmailTemplateModeSelectModalBody';
import { jsx as _jsx } from "react/jsx-runtime";
const EmailTemplateModeWithDataFetching = WithBusinessUnitsDataFetching(EmailTemplateModeSelectModalBody);
function EmailTemplateModeSelectModalBodyWithBusinessUnit(props) {
  const {
    canAccessBusinessUnit
  } = props;
  if (canAccessBusinessUnit) {
    return /*#__PURE__*/_jsx(EmailTemplateModeWithDataFetching, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(EmailTemplateModeSelectModalBody, Object.assign({}, props));
}
export default EmailTemplateModeSelectModalBodyWithBusinessUnit;